// src/components/panels/CapturedPiecesPanel.tsx
import React from "react";
import { Piece } from "../../types/Board.ts";
import { PIECE_DEFINITIONS } from "../../data/pieceDefinitions.ts";

interface CapturedPiecesPanelProps {
  capturedPieces: { white: Piece[]; black: Piece[] };
  materialAdvantage: number;
  capturedValues: { white: number; black: number };
}

export const CapturedPiecesPanel: React.FC<CapturedPiecesPanelProps> = ({
  capturedPieces,
  materialAdvantage,
  capturedValues,
}) => {
  // ⭐ CRITICAL FIX: Ensure capturedPieces is always a valid object with arrays
  const safeCapturedPieces = capturedPieces || { white: [], black: [] };
  const safeWhiteCaptured = safeCapturedPieces.white || [];
  const safeBlackCaptured = safeCapturedPieces.black || [];
  
  return (
    <div>
      <h3 style={{ margin: "0 0 7px 0", color: "#333", fontSize: "14px" }}>
        Captured Pieces:
      </h3>

      {materialAdvantage !== 0 && (
        <div
          style={{
            marginBottom: "7px",
            padding: "7px",
            backgroundColor: materialAdvantage > 0 ? "#d3e7d5ff" : "#e3d0d7ff",
            borderRadius: "4px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "11px",
            color: materialAdvantage > 0 ? "#2e7d32" : "#c2185b",
            border: "2px solid",
            borderColor: materialAdvantage > 0 ? "#4caf50" : "#e91e63",
          }}
        >
          {materialAdvantage > 0 ? "⚪ White" : "⚫ Black"} +
          {Math.abs(materialAdvantage).toFixed(2)} Value
        </div>
      )}

      <div style={{ marginBottom: "10px" }}>
        <div
          style={{
            fontWeight: "bold",
            marginBottom: "4px",
            color: "#666",
            fontSize: "12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>White Captured Pieces: {safeBlackCaptured.length}</span>
          <span
            style={{
              backgroundColor: "#fff",
              color: "#333",
              padding: "2px 6px",
              borderRadius: "3px",
              fontSize: "10px",
              fontWeight: "bold",
              border: "1px solid #333",
            }}
          >
            {capturedValues.white.toFixed(2)} Value
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px",
            minHeight: "52px",
            padding: "6px",
            backgroundColor: "#fbf4f4ff",
            borderRadius: "4px",
            border: "1px solid #ddd",
          }}
        >
          {safeBlackCaptured.length === 0 ? (
            <span
              style={{
                color: "#999",
                fontStyle: "italic",
                fontSize: "10px",
              }}
            >
              None
            </span>
          ) : (
            safeBlackCaptured.map((piece, index) => (
              <div
                key={`${piece.type}-${index}`}
                style={{
                  width: "47px",
                  height: "47px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#a5d6a7",
                  borderRadius: "4px",
                  border: "1px solid #4caf50",
                  position: "relative",
                }}
                title={piece.type}
              >
                <img
                  src={`/pieces/${(piece.abbreviation || PIECE_DEFINITIONS[piece.type.toLowerCase()]?.abbreviation || 'pwn').toLowerCase()}.png`}
                  alt={piece.type}
                  style={{ width: "44px", height: "44px", opacity: 1 }}
                />
              </div>
            ))
          )}
        </div>
      </div>

      <div>
        <div
          style={{
            fontWeight: "bold",
            marginBottom: "4px",
            color: "#666",
            fontSize: "12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Black Captured Pieces: {safeWhiteCaptured.length}</span>
          <span
            style={{
              backgroundColor: "#333",
              color: "#fff",
              padding: "2px 6px",
              borderRadius: "3px",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {capturedValues.black.toFixed(2)} Value
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px",
            minHeight: "52px",
            padding: "6px",
            backgroundColor: "#f3f3f3ff",
            borderRadius: "4px",
            border: "1px solid #ddd",
          }}
        >
          {safeWhiteCaptured.length === 0 ? (
            <span
              style={{
                color: "#999",
                fontStyle: "italic",
                fontSize: "10px",
              }}
            >
              None
            </span>
          ) : (
            safeWhiteCaptured.map((piece, index) => (
              <div
                key={`${piece.type}-${index}`}
                style={{
                  width: "47px",
                  height: "47px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ef9a9a",
                  borderRadius: "4px",
                  border: "1px solid #e91e63",
                  position: "relative",
                }}
                title={piece.type}
              >
                <img
                  src={`/pieces/${(piece.abbreviation || PIECE_DEFINITIONS[piece.type.toLowerCase()]?.abbreviation || 'pwn').toLowerCase()}.png`}
                  alt={piece.type}
                  style={{
                    width: "44px",
                    height: "44px",
                    opacity: 1,
                    filter: "brightness(0) invert(1) drop-shadow(1px 1px 1px rgba(0,0,0,0.5))",
                  }}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
